(function() {

	let trackingData = $(document.body).attr("data-track");

	let trackFbEvent = function(event, data) {
		if (typeof fbq !== "undefined") {
			fbq('track', event, data);	
		}
	}

	if (trackingData) {
		trackingData = JSON.parse(trackingData);

		let facebookData = trackingData["fb"];

		if (facebookData) {
			let event = facebookData.event;
			let data  = facebookData.data || null;

			trackFbEvent(event, data);
		}
	}

	CartItems.on("add", function(item) {
		let data = {
			value: item.final_price,
			currency: item.currency || "EUR",
			content_ids: [ item.product_group_id ],
			contents: [{
				id: item.product_group_id,
				quantity: 1,
				item_price: item.final_price
			}],
			content_type: "product",
			content_name: getTrackingProductName(item),
			content_category: item.category.name
		};

		trackFbEvent("AddToCart", data);
	});

	let trackImpressions = function(parent, lists) {
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let listName = '';
		let listId = '';

		if (!lists) {
			if (parent) {
				lists = $(parent).find("[data-product-list]");
			} else {
				lists = $("[data-product-list]");
			}
		} else {
			listName = $(parent).attr("data-product-list");
			listId = $(parent).attr("data-product-list-id");
		}

		lists.each(function (ind, list) {
			
			let $list = $(list);

			if ($list.attr("data-product-list") && $list.attr("data-product-list-id")) {
				listName = $list.attr("data-product-list");
				listId = $list.attr("data-product-list-id");
			}

			let products = [];

			$list.find("[data-ga]").each(function() {

				let itemProps = $(this).attr("data-ga");
				let currency  = $(this).attr("data-currency") || "EUR";

				if (itemProps) {
					itemProps = JSON.parse(itemProps);

					products.push({
						item_id: itemProps.id,
						item_name: itemProps.name,
						currency: currency,
						discount: parseFloat(itemProps.discount),
						index: itemProps.position,
						item_brand: itemProps.brand,
						item_category: itemProps.category,
						price: parseFloat(itemProps.base_price),
						quantity: 1
					}); 
				}
			});

			// Clear the previous ecommerce object.
			dataLayer.push({ ecommerce: null });
			// Push data layer event
			dataLayer.push({
				event: "view_item_list", 
				ecommerce: {
					item_list_id: listId,
					item_list_name: listName,
					items: products
				}
			});
		});

	}

	let trackDetail = function() {

		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let $product = $("[data-product-detail]");
		let data     = $product.attr("data-ga");
		let currency = $product.attr("data-currency") || "EUR";

		if (data) {
			data = JSON.parse(data);

			// Clear the previous ecommerce object.
			dataLayer.push({ ecommerce: null });
			// Push data layer event
			dataLayer.push({
				event: 'view_item', 
				ecommerce: {
					currency: currency,
					value: parseFloat(data.price),
					items: [
					{
						item_id: data.id,
						item_name: data.name,
						discount: parseFloat(data.discount),
						item_brand: data.brand,
						item_category: data.category,
						price: parseFloat(data.base_price),
						quantity: 1,
						id: data.id,
					}
					]
				}
			});
		}

	}

	let trackProductAdd = function(item) {
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: 'add_to_cart', 
			ecommerce: {
				currency: item.currency || "EUR",
				value: parseFloat(item.final_price),
				items: [
				{
					item_id: item.product_group_id,
					item_name: getTrackingProductName(item),
					discount: parseFloat(item.discount),
					item_brand: item.manufacturer.title,
					item_category: item.category.name,
					price: parseFloat(item.base_price),
					quantity: 1,
				}
				]
			}
		});
	}

	let trackProductRemove = function(items) {
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let item     = items[0];
		let quantity = items.length;
		let currency = document.body.dataset["currency"] || "EUR";

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				currency: currency,
				value: parseFloat(item.final_price) * quantity,
				items: [
				{
					item_id: item.product_group_id,
					item_name: item.title,
					discount: parseFloat(item.base_price) - parseFloat(item.final_price),
					item_brand: item.manufacturer.title,
					item_category: item.category.title,
					price: parseFloat(item.base_price),
					quantity: quantity
				}
				]
			}
		});
	}

	let trackCheckoutProcess = function() {
		// Do nothing if ga is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}
	
		let data = $(document.body).attr("data-track");

		if (data) {
			data = JSON.parse(data);

			// No ga data
			if (!data.ga) {
				return;
			}

			if (data.ga.event == "Checkout") {
				trackCheckout(data.ga);
			}

			if (data.ga.event == "Purchase") {
				trackPurchase(data.ga);
			}
		}

	}

	let trackCheckout = function(data) {
		// Do nothing if ga is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let total = 0;
		let currency = document.body.dataset["currency"] || "EUR";

		data.items.forEach(item => {
			total += parseFloat(item.price) - parseFloat(item.discount);
		});

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: "begin_checkout", 
			ecommerce: {
				currency: currency,
				value: total,
				items: data.items
			}
		});
	}

	let trackPurchase = function(data) {

		// Do nothing if ga is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let currency = document.body.dataset["currency"] || "EUR";

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: "purchase", 
			ecommerce: {
				transaction_id: data.transaction_id,
				value         : data.productsPrice,
				shipping      : data.shipping,
				currency      : currency,
				coupon        : data.coupon,
				items         : data.items
			}
		});
	}

	let trackSearch = function(term) {
		// Do nothing if ga is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}
		
		dataLayer.push({
			event: "search", 
			search_term: term
		});
	}

	let getTrackingProductName = function(product) {
		let optionalTitle = product.selectedOptions.map(function (option) {
			return option.title;
		}).join(", ");

		return optionalTitle ? `${product.title} (${optionalTitle})` : product.title;
	}

	window.ECMT = {
		beforePageView: function() {
			trackDetail();
			trackImpressions();
			trackCheckoutProcess();

			CartItems.on("add", trackProductAdd);
			CartItems.on("removeGroup", trackProductRemove);
		},

		trackImpressions: function(parent, lists) {
			trackImpressions(parent, lists);
		},

		trackSearch: function(term) {
			trackSearch(term);
		}
	}

})();
